import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import MerchantRebate from 'core/modules/MerchantRebate/MerchantRebate';
import MerchantExperienceLink from 'core/modules/MerchantExperienceLink/MerchantExperienceLink';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';

import './BonusOffer.scss';

import { selectBonusOffersConfig } from '../selectors';

function BonusOffer({
  bonusId, heading, description, merchant, bonusTag, config, className, endDate,
}) {
  const componentConfig = useSelector(selectBonusOffersConfig);
  // combine component config and config which is passed through props
  const combinedConfig = {
    ...componentConfig,
    ...config,
  };
  const {
    rebateOptions, useAddToFavorite, usePeriod, seeDetailPrefix, useDateInBonusTag,
  } = combinedConfig;

  const bonusTagToShow = useDateInBonusTag ? `${bonusTag} through ${endDate}` : bonusTag;

  return (
    <MerchantExperienceLink
      className={`mn_bonusMerchantOffer ${className || ''}`}
      merchant={merchant}
      data-merchant-name={merchant.name}
      data-bonus-id={bonusId}
      data-heading={heading}
      data-description={description}
      role="listitem"
    >
      {useAddToFavorite && <FavoriteIcon merchantId={merchant.globalMerchantId} merchantName={merchant.name} />}
      <div className="mn_bonusMerchantOfferInfo">
        <div className="mn_logoWrap">
          <img
            className="mn_logo"
            data-test="bonus-offer-merchant-logo"
            src={merchant.logoUrls._120x60}
            alt={merchant.name}
          />
        </div>
        <div className="mn_bonusTagWrap" data-test="bonus-offers-tag">
          <p>{bonusTagToShow}</p>
        </div>
        <div className="mn_bottomWrap">
          <h2 className="mn_heading" data-test="bonus-offer-heading">{heading}{usePeriod ? '.' : ''}</h2>
          {description
            ? <p className="mn_description" data-test="bonus-offers-description">{description}</p>
            : <MerchantRebate {...merchant.rebate} {...rebateOptions} />
          }
          <p className="mn_details">
            {seeDetailPrefix && <span className="mn_seeDetailsPrefix">{seeDetailPrefix}</span>}
            <span className="mn_seeDetailsSuffix">See details</span>
          </p>
        </div>
      </div>
    </MerchantExperienceLink>
  );
}

BonusOffer.propTypes = {
  bonusId: PropTypes.number.isRequired,
  heading: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  merchant: PropTypes.shape({}).isRequired,
  bonusTag: PropTypes.string.isRequired,
  config: PropTypes.shape({}),
  className: PropTypes.string,
};

BonusOffer.defaultProps = {
  description: false,
  className: null,
  config: {},
};

export default BonusOffer;
